import type { FC } from "react";
import {
  type InspectionSeverity,
  inspectionSeverityOptions,
} from "../../api/dto/InspectionFinding";
import { Badge, BadgeStyle } from "../data/Badge";

export const InspectionFindingSeverityBadge: FC<{ severity: InspectionSeverity }> = (props) => {
  const styleMapping = {
    info: BadgeStyle.info,
    warning: BadgeStyle.warning,
    critical: BadgeStyle.danger,
    lsr_violation: BadgeStyle.danger,
    Geen: BadgeStyle.default,
  };

  return (
    <Badge style={styleMapping[props.severity ?? "Geen"]}>
      {inspectionSeverityOptions[props.severity]}
    </Badge>
  );
};
